import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";

const LegalPagesSettings = () => {
    const { t } = useTranslation();

    const tutorials = [
        {
            title: t("settings.resources.tutorials.homepage"),
            href: "https://mailvista.ai/tutorielsinteractifs/Tuto-page-accueil/index.html",
            icon: "🏠",
        },
        {
            title: t("settings.resources.tutorials.customViews"),
            href: "https://mailvista.ai/tutorielsinteractifs/Tuto-custom-view/index.html",
            icon: "💜",
        },
        {
            title: t("settings.resources.tutorials.mailBox"),
            href: "https://mailvista.ai/tutorielsinteractifs/Tuto-boite-mails/index.html",
            icon: "📬",
        },
        {
            title: t("settings.resources.tutorials.vistassistant"),
            href: "https://mailvista.ai/tutorielsinteractifs/Tuto-assistant/index.html",
            icon: "🤩",
        },
    ];

    return (
        <div className="flex flex-col gap-8">
            <DialogHeader>
                <DialogTitle className="font-bold leading-none">
                    {t("settings.resources.title")}
                </DialogTitle>
                <p className="text-xs">{t("settings.resources.subtitle")}</p>
            </DialogHeader>
            <div className="mx-auto flex max-w-155 flex-col gap-6 text-md">
                <p className="text-center text-sm">
                    {t("settings.resources.description")}
                </p>
                <div className="border-border-primary align-center flex flex-col gap-6 rounded-md border p-6">
                    <h2 className="text-center text-lg font-bold">
                        {t("settings.resources.tutorials.title")}
                    </h2>
                    <div className="flex w-full flex-wrap items-center justify-center gap-8 text-sm">
                        {tutorials.map((tutorial) => (
                            <div key={tutorial.title}>
                                <a
                                    className="border-border-primary flex h-25 w-60 flex-col items-center justify-center rounded-xl border bg-accent p-8 text-center transition-all duration-100 hover:bg-accent/80"
                                    href={tutorial.href}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <span className="text-2xl">
                                        {tutorial.icon}
                                    </span>
                                    <span>{tutorial.title}</span>
                                </a>
                            </div>
                        ))}
                    </div>
                    <a
                        className="mx-auto flex w-fit rounded-full bg-primary px-5 py-3 text-primary-foreground transition-all duration-100 hover:bg-primary/90"
                        href="https://mailvista.ai/tutorielsinteractifs/"
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        {t("settings.resources.tutorials.allLink")}
                    </a>
                </div>

                <div className="border-border-primary align-center flex flex-col gap-6 rounded-md border p-6">
                    <h2 className="text-center text-lg font-bold">
                        {t("settings.resources.userGuide.title")}
                    </h2>
                    <p className="text-center text-sm">
                        {t("settings.resources.userGuide.text")}
                    </p>
                    <a
                        className="mx-auto w-fit rounded-full bg-primary px-5 py-3 text-primary-foreground transition-all duration-100 hover:bg-primary/90"
                        href="https://mailvista.ai/help/"
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        {t("settings.resources.userGuide.link")}
                    </a>
                </div>
            </div>
            <div />
        </div>
    );
};

export default LegalPagesSettings;
